import {OptionType} from 'platform/components';

import i18n from '@dms/i18n';

export const GROUNDING_REASON_OPTIONS: OptionType[] = [
  {
    label: i18n.t('entity.serviceOrder.groundingReason.partsNotAvailable'),
    value: 'PARTS_NOT_AVAILABLE',
  },
  {
    label: i18n.t('entity.serviceOrder.groundingReason.pendingTipsCase'),
    value: 'PENDING_TIPS_CASE',
  },
  {
    label: i18n.t('entity.serviceOrder.groundingReason.missingSoftwareUpdate'),
    value: 'MISSING_SOFTWARE_UPDATE',
  },
  {
    label: i18n.t('entity.serviceOrder.groundingReason.missingWorkshopCapacity'),
    value: 'MISSING_WORKSHOP_CAPACITY',
  },
  {
    label: i18n.t('entity.serviceOrder.groundingReason.pendingFinancialConfirmationFromInsurance'),
    value: 'PENDING_FINANCIAL_CONFIRMATION_FROM_INSURANCE',
  },
  {
    label: i18n.t('entity.serviceOrder.groundingReason.pendingFinancialConfirmationFromCustomer'),
    value: 'PENDING_FINANCIAL_CONFIRMATION_FROM_CUSTOMER',
  },
];
